/**
 * Define as configurações padrão de validação para o formulário.
 *
 * Este método configura o validador jQuery com os elementos de erro,
 * regras de posicionamento de erro, e classes de destaque para os campos
 * válidos e inválidos.
 */
export function setValidationDefaults() {
  $.validator.setDefaults({
    errorElement: "div",
    errorPlacement: function (error, element) {
      error.addClass("invalid-feedback alert alert-danger");
      if (element.prop("type") === "checkbox") {
        error.insertAfter(element.siblings("label"));
      } else {
        error.insertAfter(element);
      }
    },
    highlight: function (element) {
      $(element).addClass("is-invalid").removeClass("is-valid");
    },
    unhighlight: function (element) {
      $(element).addClass("is-valid").removeClass("is-invalid");
    },
  });
}

/**
 * Inicializa as validações de formulário com regras e mensagens específicas
 * para os formulários de registro, login, recuperação de senha e redefinição de senha.
 *
 * Este método define regras comuns de validação para campos de email e senha
 * e personaliza as mensagens de erro em português.
 */
export function initializeValidation() {
  const commonRules = {
    login: {
      required: true,
    },
  };

  const commonMessages = {
    login: {
      required: "Digite seu Login",
    },
  };

  /**
   * Validação para o formulário de registro.
   * Configura as regras e mensagens específicas para os campos de nome,
   * sobrenome, senha e confirmação de senha.
   */
  $("#registerForm").validate({
    rules: {
      first_name: "required",
      last_name: "required",
      password: {
        required: true,
        minlength: 6,
      },
      repeat_password: {
        required: true,
        equalTo: "[name='password']",
      },
      ...commonRules,
    },
    messages: {
      first_name: "Digite seu Nome",
      last_name: "Digite seu Sobrenome",
      password: {
        required: "Digite sua Senha",
        minlength: "Sua senha deve conter ao menos 6 caracteres!",
      },
      repeat_password: {
        required: "Digite Sua Senha",
        equalTo: "As senhas não estão iguais!",
      },
      ...commonMessages,
    },
  });

  /**
   * Validação para o formulário de recuperação de senha.
   * Utiliza regras e mensagens comuns para o campo de e-mail.
   */
  $("#forgotForm").validate({
    rules: commonRules,
    messages: commonMessages,
  });

  /**
   * Validação para o formulário de redefinição de senha.
   * Aplica validações específicas para os campos de senha e confirmação de senha.
   */
  $("#resetForm").validate({
    rules: {
      password: {
        required: true,
        minlength: 6,
      },
      repeat_password: {
        required: true,
        equalTo: "[name='password']",
      },
    },
    messages: {
      password: {
        required: "Digite sua Senha",
        minlength: "Sua senha deve conter ao menos 6 caracteres!",
      },
      repeat_password: {
        required: "Digite Sua Senha",
        equalTo: "As senhas não estão iguais!",
      },
    },
  });
}
